module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kanto-d8c30317dc4b54175897d601d1a9d255.png";